/** Textos da secção "discord". Chaves planas "discord.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "discord.featureWipes": "Avisos de wipe",
    "discord.featureSupport": "Suporte por ticket",
    "discord.featureEvents": "Eventos e updates",
    "discord.featureCommunity": "Comunidade ativa",
    "discord.eyebrow": "Comunidade",
    // Título: "{titleBefore} <destaque>{titleHighlight}</destaque> {titleAfter}" (titleAfter pode ser vazio)
    "discord.titleBefore": "Entra na",
    "discord.titleHighlight": "Comunidade",
    "discord.titleAfter": "ZRS",
    "discord.desc":
        "Avisa-te dos wipes, recebe suporte, participa em eventos e acompanha todas as novidades do servidor.",
    "discord.join": "Entrar no Discord",
};
const en = {
    "discord.featureWipes": "Wipe alerts",
    "discord.featureSupport": "Ticket support",
    "discord.featureEvents": "Events & updates",
    "discord.featureCommunity": "Active community",
    "discord.eyebrow": "Community",
    "discord.titleBefore": "Join the ZRS",
    "discord.titleHighlight": "Community",
    "discord.titleAfter": "",
    "discord.desc":
        "Get wipe alerts and support, join events and keep up with all the latest server news.",
    "discord.join": "Join Discord",
};

export default { pt, en };
